import React, { useState, useEffect } from "react";
import "../loader/counter.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
const WinnerAnnouncement = () => {
  const [countdown, setCountdown] = useState(3);
  const [showWinner, setShowWinner] = useState(false);
  const location = useLocation();
  const team = location.state.team;
  const navigate = useNavigate();


  useEffect(() => {
    if (showWinner) {
        setTimeout(moveTo,2000);
    }
  }, [showWinner]);

  function moveTo(){
    navigate("/")
  }

    var count = countdown;

    const countdownInterval = setInterval(() => {
      count--;
      setCountdown(count);

      if (count === 0) {
        clearInterval(countdownInterval);
        setShowWinner(true);
      }
    }, 1000);
  

  return (
    <div>
      {showWinner ? (
        <div className="winner-container animated">
          <h1 className="winner-text">{team} is Winner!!</h1>
        </div>
      ) : (
        <div className="countdown-container">
          <h1 className="countdown-text">{countdown}</h1>
          {/* <button onClick={startCountdown} className="start-button">
            Start Countdown
          </button> */}
        </div>
      )}
    </div>
  );
};

export default WinnerAnnouncement;
